<template>
    <div>
        <az-break-title title="Faturas" />

        <div v-if="dados">

            <div class="card" style="padding: 0px;">

                <div class="card-body">
                    <div class="row" v-if="1 == 0">
                        <div class="col col-12 col-md-4">
                            <az-input 
                                label="Número de Guias por Fatura" 
                                type="number"
                                required 
                                :validate="validate"
                                v-model="dados.in_guias"/>
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input 
                                label="Notificar vencimento de faturas (em dias)" 
                                type="number"
                                :validate="validate"
                                v-model="dados.in_dias_notificar"/>
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input 
                                label="Notificar ao faturamento" 
                                type="checkbox"
                                :validate="validate"
                                v-model="dados.fl_notificar" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-12 col-md-4">
                            <az-input 
                                label="Tipo de prazo para envio das Faturas" 
                                type="select"
                                optionsMode="json"
                                optionsData="id" 
                                optionsDisplay="search"
                                :optionsList="tiposPrazo"
                                :validate="validate"
                                required
                                v-model="dados.ch_tipo_prazo "/>
                        </div>

                        <!-- Dias Fixo -->
                        <div class="col col-12 col-md-4" v-if="dados.ch_tipo_prazo == 'F'">
                            <az-input 
                                label="Dia do Envio" 
                                type="number"
                                required 
                                :validate="validate"
                                v-model="dados.in_dia_inicial"/>
                        </div>

                        <div class="col col-12 col-md-4" v-if="dados.ch_tipo_prazo == 'F' || dados.ch_tipo_prazo == 'L'"> 
                            <az-input 
                                label="Vencimento das Faturas (em dias)" 
                                type="number"
                                placeholder="Informado no envio..."
                                :validate="validate"
                                v-model="dados.in_dia_vencimento"/>
                        </div>

                        <!-- Livre --> 
                        <div class="col col-12 col-md-2" v-if="dados.ch_tipo_prazo == 'P'">
                            <az-input 
                                label="Dia Inicial" 
                                type="number"
                                required 
                                :validate="validate"
                                v-model="dados.in_dia_inicial"/>
                        </div>

                        <div class="col col-12 col-md-2" v-if="dados.ch_tipo_prazo == 'P'">
                            <az-input 
                                label="Dia Final" 
                                type="number"
                                required 
                                :validate="validate"
                                v-model="dados.in_dia_final"/>
                        </div>

                        <div class="col col-12 col-md-4" v-if="dados.ch_tipo_prazo == 'P'"> 
                            <az-input 
                                label="Vencimento das Faturas (em dias)" 
                                type="number"
                                placeholder="Informado no envio..."
                                :validate="validate"
                                v-model="dados.in_dia_vencimento"/>
                        </div>

                    </div>

                    <!-- Observações -->
                    <div class="row">
                        <div class="col col-12">
                            <az-input 
                                label="Observações" 
                                type="textarea"
                                v-model="dados.st_descricao"/>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col col-12">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Não permitir guia com exame com material pendente na fatura"
                                v-model="dados.fl_block_material_pendente" />
                        </div>
                    </div>
                    
                </div>

                    

            </div>

            <div class="card" v-if="dados.ch_tipo_prazo == 'C'">
                <div class="card-header">
                    Calendário 
                </div>

                <div class="card-body">

                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Data Inicial</th>
                                <th>Data Final</th>
                                <th>Vencimento</th>
                                <th>Contrato</th>
                                <th>Obs</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(calend, ic) in dados.parametro_fatura_calendarios" :key="ic">
                                <td class="text-nowrap">
                                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="editarCalendario (calend)">
                                        <i class="fas fa-pen"></i>
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="removerCalendario (calend)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                                <td>{{ $util.getFormatDate(calend.dt_inicio) }}</td>
                                <td>{{ $util.getFormatDate(calend.ch_tipo_calendario == 'D' ? calend.dt_inicio : calend.dt_final) }}</td>
                                <td>{{ $util.getFormatDate(calend.dt_dia_vencimento) }}</td>
                                <td>{{ calend.contrato ? calend.contrato.search : '-' }}</td>
                                <td>{{ calend.st_observacoes }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <button type="button" class="btn btn-outline-primary" @click="incluir ()">Incluir</button>

                </div>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="modalCalendario" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Calendário</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="edicao">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Referência"
                                    type="button-group"
                                    :optionsList="[{ id: 'P', search: 'Período'}, { id: 'D', search: 'Data'}]"
                                    required 
                                    :validate="validate"
                                    v-model="edicao.ch_tipo_calendario" />
                            </div>
                        </div>
                        <div class="row" v-if="edicao.ch_tipo_calendario == 'P'">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="De"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="edicao.dt_inicio" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Até"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="edicao.dt_final" />
                            </div>
                        </div>
                        <div class="row" v-if="edicao.ch_tipo_calendario == 'D'">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Data"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="edicao.dt_inicio" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Vencimento"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="edicao.dt_dia_vencimento" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    v-model="edicao.st_observacoes" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Contrato"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsData="id_contrato_operadora"
                                    optionsDisplay="search"
                                    service="contrato_operadoras.index"
                                    :optionsParm="{ id_operadora: dados.id_operadora, guias: true }"
                                    optionsName="contratos-busca-guia"
                                    placeholder="Todos os Contratos..."
                                    :edicao="dados.id_operadora ? true : false"
                                    v-model="edicao.id_contrato_operadora">
                                </az-input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvarCalendario ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubmit from '../../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            dados: null, 
            item: null, 
            search: "", 
            edicao: null, 
            validate: false, 
            tiposPrazo: [
                { id: 'C', search: 'Calendário' },
                { id: 'F', search: 'Dia Fixo' },
                { id: 'L', search: 'Livre' },
                { id: 'P', search: 'Período' },
            ]
        }
    },

    components: { 
        AzBreakTitle,
        AzInput, 
        AzSubmit, 
    },

    props: ['id_operadora'],

    methods: { 
        
        incluir () { 
            this.validate = false; 
            
            this.edicao = { 
                id_parametro_fatura_calendario: null,
                id_parametro_fatura: this.dados.id_parametro_fatura, 
                dt_inicio: null, 
                dt_final: null,
                dt_dia_vencimento: null, 
                fl_ativo: true, 
                ch_tipo_calendario: "P",
                id_contrato_operadora: "", 
            };

            $('#modalCalendario').modal('show');
        },

        removerCalendario (item) { 

            if ( !confirm("Confirma remover o calendário de " + this.$util.getFormatDate(item.dt_inicio) + '?' ) ) { 
                return;
            }

            this.$util.remover (this, { 
                service: 'parametro_fatura_calendarios',
                dados: item, 
                callback: () => { 
                    this.load ();
                }
            });

        },

        editarCalendario (item) { 
            this.validate = false; 
            this.edicao = { ...item };
            $('#modalCalendario').modal('show');
        },

        salvarCalendario () { 

            this.$util.atualizar (this, { 
                service: 'parametro_fatura_calendarios',
                dados: this.edicao,
                modal: 'modalCalendario',
                callback: () => { 
                    this.load ();
                }
            })

        },

        toggle () { 
            // 
        },

        load () { 
            let query = { q: [ 
                {
                    name: 'parametro_faturas.index',
                    id: 'lista',
                    parms: { 
                        where: { 
                            id_operadora: this.id_operadora,
                        }
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data[0];
                    }
                });
        },

        atualizar () { 

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                   
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        { 
                            name: 'parametro_faturas.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.dados,
                            }
                        }
                    ]};
                    
                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }

            });

        }
    },

    mounted () { 
        this.load ();
    }
}
</script>